import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_EP_SUPPORT, IID_GR_RESOURCES } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDGrResourcesState extends EntityState<IID_GR_RESOURCES, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_GR_RESOURCES })
@InterfaceDataStore(InterfaceName.GR_RESOURCES)
export class IIDGrResourcesStore extends EntityStore<IIDGrResourcesState> {

  constructor() {
    super([]);
  }

}
